"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const positions_1 = require("../Core/positions");
/**
 * Container
 * @block
 */
const Container = ({ children, backgroundColor, backgroundImage, className, classNames = [], size = '', backgroundPosition = 'center', backgroundSize = 'cover', id, }) => (react_1.default.createElement("div", { className: className ||
        (0, classnames_1.default)(`container${size ? `-${size}` : ''}`, backgroundColor && `bg-${backgroundColor}`, backgroundColor === 'dark' && 'text-light', ...classNames), style: Object.assign({ backgroundPosition: positions_1.positionsMap[backgroundPosition] || 'center', backgroundSize }, (backgroundImage
        ? { backgroundImage: `url('${backgroundImage.src}')` }
        : {})), id: id },
    backgroundImage && backgroundColor && (react_1.default.createElement("div", { className: (0, classnames_1.default)('container-overlay', `bg-${backgroundColor}`) })),
    children));
exports.default = Container;
